






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
    components: {}
})
export default class VTreeSelectEnhanced extends Vue {

    @Prop(Object) extra!: any
    @Prop(Array) secondarySchema!: Array<object>
    @Prop(Object) menuProps!: object
    @Prop(String) label!: string
    @Prop(Array) errorMessages!: Array <object>
    @Prop() value!: any

    elements: object[] = []
    result: any = []
    isRequired: boolean = false
    open: any = []
    dotransition: boolean = true
    doreturnobject: boolean = true
    activeitems: any = []
    showList: boolean = false
    selectedName: string = ''

    updateOpen(list: Array<any>) {
      // https://next.vuetifyjs.com/en/components/treeview -> Events -> update:open
      // opened branches are appended to the list, meaning last item was last
      //   opened. So, set the last item to the only open item.
      if (list.length <= 1) {
        return
      }

      this.open = [list[1]]
    }

    clearName(e: any) {
      this.$emit('change', '')
      this.$emit('observationheader', e)
      this.$emit('input', '')

      this.selectedName = '';
      this.showList = false;
    }

    // when you click on a leaf node, this event is fired off
    selectedItem(node: any) {
        this.$emit('change', node.value)

        // this event will update the collapsable panel header
        this.$emit('observationheader', node)

        // this ensures the dirty flag etc is set for validation
        this.$emit('input', node.value)

        this.selectedName = node.parent + ' - ' + node.name;
        this.showList = false;
    }

    checkChildren(parent : any, id : string) {
        if(parent.children) {
            for(let i = 0; i < parent.children.length; i++) {
                const c = parent.children[i]
                if(c.id === id) {
                    return true;
                }
            }
        }
        return false
    }

    collapseOthers(node: any) {
    }

    mounted() {
        if(this.extra && this.extra.vvalidate && this.extra.vvalidate === 'required') {
            this.isRequired = true;
        }

        // convert the secondaryschema to the format required by vtreeselect
        this.secondarySchema.forEach((sec: any) => {

            let node = {
                name: sec.description as string,
                children: [] as object,
                value: sec.code as string,
                id: sec.code as string
            }

            // combine all the children
            let kids: Array <object> = []
            sec.children.forEach((kid: any) => {
                kids.push({
                    value: kid.code,
                    name: kid.description,
                    parent: sec.description,
                    id: kid.code
                });

                if (this.value) {
                    if (kid.code === this.value) {
                        this.selectedItem({
                            value: kid.code,
                            name: kid.description,
                            parent: sec.description,
                            id: kid.code
                        });
                    }
                }
            })

            node.children = kids
            node.name += ` (${kids.length})`

            this.elements.push(node);
        })
    }
}

